import { AddLogBookEntryMaster } from 'src/pages/Setup/LogBookEntryMaster/AddLogBookEntryMaster';
import { EditLogBookEntryMaster } from 'src/pages/Setup/LogBookEntryMaster/EditLogBookEntryMaster';
import { LogBookEntryMaster } from 'src/pages/Setup/LogBookEntryMaster/Index';

export const logBookEntryMasterRoutes = [
  { path: '/log/book/entry/master', component: LogBookEntryMaster },
  { path: '/log/book/entry/master/Add', component: AddLogBookEntryMaster },
  { path: '/log/book/entry/master/:id', component: EditLogBookEntryMaster },
];
